import React, { useEffect, useState } from "react";
import "./DhenkanalNavbarPage.css";

import health1 from "../assest/health1.jpeg";
import health2 from "../assest/health2.jpeg";
import cmPhoto from "../assest/cm-bihar.jpg";
import ministerPhoto from "../assest/Nishan.jpeg";
import { 
    FaArrowUp, 
    FaChalkboard, 
    FaChevronLeft, 
    FaChevronRight, 
    FaCommentDots, 
    FaEnvelope, 
    FaFileAlt, 
    FaFileDownload, 
    FaHandHoldingHeart, 
    FaHeartbeat, 
    FaImages, 
    FaNewspaper, 
    FaPhoneAlt, 
    FaQrcode, 
    FaRibbon, 
    FaShareAlt, 
    FaShieldAlt, 
    FaUsers, 
    FaVideo 
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Dhealnavbar from "../Navbar/dhealnavbar";

const bannerImages = [
    health1,
    health2,
];

const contactsData = [
    { name: "Shri Nishant", nameKey: "names.nishant", title: "Health Minister", titleKey: "titles.healthMinister", phone: "0612-2215330" },
    { name: "Sri Kumar Ravi, I.A.S.", nameKey: "names.kumarRavi", title: "Secretary", titleKey: "titles.secretary", phone: "0612 2215809", email: "health-bih@nic.in" },
    { name: "Shri Arvind Kumar Verma, I.A.S.", nameKey: "names.arvindVerma", title: "Special Secretary", titleKey: "titles.specialSecretary", phone: "0612-2234992" },
    { name: "Sri Thiyagarajan S.M., I.A.S.", nameKey: "names.thiyagarajan", title: "Special Secretary", titleKey: "titles.specialSecretary", phone: "0612-2217681" },
    { name: "Sri Subrat Kumar Sen, I.A.S.", nameKey: "names.subratSen", title: "Managing Director, Bihar Medical Services & Infrastructure Corp Ltd.", titleKey: "titles.mdBmsicl", phone: "0612-2283289", email: "md-bmsicl-bih@nic.in" },
    { name: "Sri Amit Kumar Pandey, I.A.S.", nameKey: "names.amitPandey", title: "Executive Director, SHSB", titleKey: "titles.edShsb", phone: "0612-2290328", email: "ed_shsb@yahoo.co.in" },
    { name: "Dr. Anupama Singh, I.A.S.", nameKey: "names.anupamaSingh", title: "Joint Secretary", titleKey: "titles.jointSecretary" },
    { name: "Sri Vaibhav Choudhary, I.A.S.", nameKey: "names.vaibhavChoudhary", title: "Additional Secretary", titleKey: "titles.additionalSecretary" },
    { name: "Sri Dhananjay Kumar, I.A.S.", nameKey: "names.dhananjayKumar", title: "Additional Secretary", titleKey: "titles.additionalSecretary" },
    { name: "Sri Sumit Kumar, IAS", nameKey: "names.sumitKumar", title: "Project Director, Bihar State AIDS Control Society", titleKey: "titles.pdBsacs" },
    { name: "Shri Shambhu Sharan, I.A.S.", nameKey: "names.shambhuSharan", title: "Additional Secretary & Departmental Chief Vigilance Officer", titleKey: "titles.addSecCvo", phone: "9470003040", email: "js.health@bihar.gov.in" },
    { name: "Shri Sparsh Gupta, I.A.S.", nameKey: "names.sparshGupta", title: "AED SHSB", titleKey: "titles.aedShsb", phone: "0612-2284336", email: "aedshsb2@gmail.com" },
    { name: "Shri Shailesh Kumar, B.A.S.", nameKey: "names.shaileshKumar", title: "Special Secretary", titleKey: "titles.specialSecretary", phone: "9413043685" },
    { name: "Sri Mrinayak Das, I.A.S.", nameKey: "names.mrinayakDas", title: "Special Secretary", titleKey: "titles.specialSecretary" },
    { name: "Md. Shafique, B.A.S.", nameKey: "names.mdShafique", title: "Joint Secretary", titleKey: "titles.jointSecretary" },
    { name: "Smt. Renu Kumari, B.A.S.", nameKey: "names.renuKumari", title: "O.S.D", titleKey: "titles.osd", phone: "8210106778" },
    { name: "Shri Surendra Roy, B.A.S.", nameKey: "names.surendraRoy", title: "O.S.D", titleKey: "titles.osd" },
    { name: "Sri Manoj Kumar, B.A.S.", nameKey: "names.manojKumar", title: "O.S.D cum Joint Secretary", titleKey: "titles.osdJointSec" },
    { name: "Sri Kaushlendra Kumar, B.A.S.", nameKey: "names.kaushlendraKumar", title: "P.S To Minister", titleKey: "titles.psMinister" }
];

const importantLinksData = [
    { title: "Letters & Circulars", titleKey: "links.letters", type: "doc" },
    { title: "Asset Declaration", titleKey: "links.assetDecl", type: "asset" },
    { title: "Cabinet decisions", titleKey: "links.cabinetDec", type: "doc" },
    { title: "IEC Materials on COVID-19", titleKey: "links.iecCovid", type: "share" },
    { title: "Notifications", titleKey: "links.notifications", type: "doc" },
    { title: "Office Orders", titleKey: "links.officeOrders", type: "doc" },
    { title: "Transfer & Posting", titleKey: "links.transferPosting", type: "network" },
    { title: "Allotment", titleKey: "links.allotment", type: "share" },
    { title: "Recruitment", titleKey: "links.recruitment", type: "group" },
    { title: "Notice Board", titleKey: "links.noticeBoard", type: "board" },
    { title: "Forms", titleKey: "links.forms", type: "download" },
    { title: "Tender", titleKey: "links.tender", type: "tender" },
    { title: "Chief Ministers Medical Assistance Fund", titleKey: "links.cmFund", type: "doc" },
    { title: "RTI", titleKey: "links.rti", type: "doc" },
    { title: "Online Performance Appraisal Report (ePAR SPARROW)", titleKey: "links.epar", type: "doc" },
    { title: "Departmental Letter", titleKey: "links.deptLetter", type: "doc" },
    { title: "COVID-19 UPDATES", titleKey: "links.covidUpdates", type: "doc" },
    { title: "Leave Approval", titleKey: "links.leaveApproval", type: "doc" },
    { title: "Acts and Rules", titleKey: "links.actsRules", type: "doc" },
    { title: "Gradation List", titleKey: "links.gradationList", type: "doc" },
    { title: "Corrigendums", titleKey: "links.corrigendums", type: "doc" },
    { title: "AES GUIDELINES", titleKey: "links.aesGuidelines", type: "doc" },
    { title: "Proceedings", titleKey: "links.proceedings", type: "doc" },
    { title: "Hindi Translation of judgement order", titleKey: "links.hindiJudgement", type: "doc" },
    { title: "Website link of the Advocate General Bihar High Court Patna", titleKey: "links.advocateGeneral", type: "doc" },
    { title: "NOC", titleKey: "links.noc", type: "doc" },
    { title: "Retirement Benefit", titleKey: "links.retireBenefit", type: "doc" },
    { title: "Mental Health Guidelines Photo", titleKey: "links.mentalPhoto", type: "doc" },
    { title: "Mental Health Guidelines Video", titleKey: "links.mentalVideo", type: "doc" },
    { title: "Resolutions", titleKey: "links.resolutions", type: "doc" }
];

const getLinkIcon = (type) => {
    switch(type) {
        case "share": return <FaShareAlt />;
        case "network": return <FaShareAlt />;
        case "group": return <FaUsers />;
        case "board": return <FaChalkboard />;
        case "download": return <FaFileDownload />;
        case "tender": return <FaHandHoldingHeart />;
        case "asset": return <FaShieldAlt />;
        default: return <FaFileAlt />;
    }
};

export default function DhenkanalNavbarPage(
    { toggleTheme,
        increaseFont,
        decreaseFont,
        resetFont }) {

    const { t, i18n } = useTranslation();
    const currentLang = i18n.language || "en";

    const localizeNumber = (numStr) => {
        if (!numStr && numStr !== 0) return numStr;
        const str = String(numStr);
        if (currentLang === "hi") {
            const hindiDigits = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];
            return str.replace(/[0-9]/g, (w) => hindiDigits[+w]);
        }
        if (currentLang === "or") {
            const odiaDigits = ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"];
            return str.replace(/[0-9]/g, (w) => odiaDigits[+w]);
        }
        return str;
    };

    const [activeBanner, setActiveBanner] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const contactsPerPage = 3;

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const indexOfLastContact = currentPage * contactsPerPage;
    const indexOfFirstContact = indexOfLastContact - contactsPerPage;
    const currentContacts = contactsData.slice(indexOfFirstContact, indexOfLastContact);
    const totalPages = Math.ceil(contactsData.length / contactsPerPage);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const bannerTimer = setInterval(() => {
            setActiveBanner((currentBanner) => (currentBanner + 1) % bannerImages.length);
        }, 3500);

        return () => clearInterval(bannerTimer);
    }, []);

    const changeBanner = (direction) => {
        setActiveBanner((currentBanner) => {
            if (direction === "next") {
                return (currentBanner + 1) % bannerImages.length;
            }

            return (currentBanner - 1 + bannerImages.length) % bannerImages.length;
        });
    };

    return (

        <div
            // className={`theme-${theme} DhenkanalNavbarPage-container`}
            // style={{ fontSize: "inherit" }}
            className="DhenkanalNavbarPage-container"

        >

            <Dhealnavbar
                increaseFont={increaseFont}
                decreaseFont={decreaseFont}
                resetFont={resetFont}
                toggleTheme={toggleTheme}
            />

            <section className="DhenkanalSecondPages-container">

                {/* LEFT — FESTIVAL POSTER */}
                <div className="DhenkanalSecondPages-left">
                    <div className="DhenkanalSecondPages-banner-slider">
                        {bannerImages.map((bannerImage, index) => (
                            <img
                                key={bannerImage}
                                src={bannerImage}
                                alt={`Bihar Banner ${index + 1}`}
                                className={`DhenkanalSecondPages-banner ${index === activeBanner ? "active" : ""}`}
                            />
                        ))}

                        <button
                            type="button"
                            className="DhenkanalSecondPages-slider-btn prev"
                            onClick={() => changeBanner("prev")}
                            aria-label="Previous banner"
                        >
                            &#8249;
                        </button>
                        <button
                            type="button"
                            className="DhenkanalSecondPages-slider-btn next"
                            onClick={() => changeBanner("next")}
                            aria-label="Next banner"
                        >
                            &#8250;
                        </button>

                        <div className="DhenkanalSecondPages-slider-dots">
                            {bannerImages.map((bannerImage, index) => (
                                <button
                                    key={`${bannerImage}-dot`}
                                    type="button"
                                    className={`DhenkanalSecondPages-slider-dot ${index === activeBanner ? "active" : ""}`}
                                    onClick={() => setActiveBanner(index)}
                                    aria-label={`Show banner ${index + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {/* RIGHT — OFFICERS SECTION */}
                {/* <div className="DhenkanalSecondPages-right"> */}

             
                    {/* <div className="DhenkanalSecondPages-officer">
                        <img
                            src={collectorName}
                            alt={t("collectorName")}
                            className="DhenkanalSecondPages-officer-photo"
                        />
                        <div className="DhenkanalSecondPages-officer-text">
                          
                            <p className="DhenkanalSecondPages-officer-title">{t("collectorTitle")}</p>
                        </div>
                    </div> */}

                   
                    {/* <div className="DhenkanalSecondPages-officer">
                        <img
                            src={usericon}
                            alt={t("spName")}
                            className="DhenkanalSecondPages-officer-photo"
                        />
                        <div className="DhenkanalSecondPages-officer-text">
                          
                            <p className="DhenkanalSecondPages-officer-title">{t("spTitle")}</p>
                        </div>
                    </div> */}

                {/* </div> */}
            </section>

            <section className="bihar-about-section" id="bihar-about-section">
                <div className="bihar-about-copy">
                    <span className="bihar-section-kicker"><FaHeartbeat /> {t("department")}</span>
                    <h1>{t("aboutDepartmentHeading")}</h1>
                    <p>{t("aboutDepartmentParagraph1")}</p>
                    {t("aboutDepartmentParagraph2") && <p>{t("aboutDepartmentParagraph2")}</p>}

                    <div className="bihar-vision-box">
                        <h2>{t("visionHeading")}</h2>
                        <p>{t("visionText")}</p>
                    </div>
                </div>

                <div className="bihar-about-details" id="key-contacts">
                    <div className="bihar-leaders">
                        <article className="bihar-leader-card">
                            <img src={cmPhoto} alt={t("officers.cmName")} />
                            <h3>{t("officers.cmName")}</h3>
                            <p>{t("officers.cmTitle")}</p>
                            <span><FaPhoneAlt /> {localizeNumber(t("officers.cmPhone"))}</span>
                        </article>

                        <article className="bihar-leader-card">
                            <img src={ministerPhoto} alt={t("officers.ministerName")} />
                            <h3>{t("officers.ministerName")}</h3>
                            <p>{t("officers.ministerTitle")}</p>
                            <span><FaPhoneAlt /> {localizeNumber(t("officers.ministerPhone"))}</span>
                        </article>
                    </div>

                    <div className="bihar-contacts-wrapper">
                        <div className="bihar-contact-heading">
                            <h2><FaHeartbeat /> {t("keyContacts")}</h2>
                            <span className="bihar-contact-badge">{localizeNumber(contactsData.length)} {t("contactsBadge")}</span>
                        </div>

                        <div className="bihar-contacts-list">
                            {currentContacts.map((contact, idx) => (
                                <article key={indexOfFirstContact + idx} className="bihar-contact-card">
                                    <h3>{contact.nameKey ? t(contact.nameKey) : contact.name}</h3>
                                    <p>{contact.titleKey ? t(contact.titleKey) : contact.title}</p>
                                    {(contact.phone || contact.email) && (
                                        <div>
                                            {contact.phone && (
                                                <span><FaPhoneAlt /> {localizeNumber(contact.phone)}</span>
                                            )}
                                            {contact.email && (
                                                <span><FaEnvelope /> {contact.email}</span>
                                            )}
                                        </div>
                                    )}
                                </article>
                            ))}
                        </div>

                        <div className="bihar-contacts-pagination">
                            <span className="bihar-pagination-info">
                                {t("showingText")} {localizeNumber(indexOfFirstContact + 1)} - {localizeNumber(Math.min(indexOfLastContact, contactsData.length))} {t("ofText")} {localizeNumber(contactsData.length)}
                            </span>
                            <div className="bihar-pagination-buttons">
                                <button
                                    type="button"
                                    className="bihar-page-btn"
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                    aria-label="Previous Page"
                                >
                                    <FaChevronLeft />
                                </button>
                                
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                    <button
                                        key={page}
                                        type="button"
                                        className={`bihar-page-btn ${currentPage === page ? "active" : ""}`}
                                        onClick={() => setCurrentPage(page)}
                                    >
                                        {localizeNumber(page)}
                                    </button>
                                ))}

                                <button
                                    type="button"
                                    className="bihar-page-btn"
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                    aria-label="Next Page"
                                >
                                    <FaChevronRight />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* HIGHLIGHTS & SCHEMES SECTION */}
            <section className="bihar-highlights-schemes-section">
                <div className="bihar-hs-container">
                    <h2 className="bihar-hs-heading">{t("highlightsHeading")}</h2>
                    <div className="bihar-highlights-grid">
                        <div className="bihar-highlight-card bihar-hl-cm">
                            <div className="bihar-hl-icon"><FaQrcode /></div>
                            <div className="bihar-hl-text">
                                <strong>{t("cmReliefFund")}</strong>
                                <span>{t("donateQr")}</span>
                            </div>
                        </div>

                        <div className="bihar-highlight-card bihar-hl-sanjivan">
                            <div className="bihar-hl-badge"><FaShieldAlt /></div>
                            <div className="bihar-hl-app-text">{t("sanjivanApp")}</div>
                        </div>

                        <div className="bihar-highlight-card bihar-hl-asset">
                            <div className="bihar-hl-asset-icon"><FaUsers /></div>
                            <div className="bihar-hl-asset-title">{t("assetDeclaration")}</div>
                        </div>

                        <div className="bihar-highlight-card bihar-hl-bsacs">
                            <div className="bihar-hl-bsacs-logo"><FaRibbon /></div>
                            <div className="bihar-hl-bsacs-text">
                                <strong>{t("bsacsName")}</strong>
                                <span>{t("bsacsFull")}</span>
                            </div>
                        </div>
                    </div>

                    <h2 className="bihar-hs-heading bihar-schemes-heading">{t("schemesHeading")}</h2>
                    <div className="bihar-schemes-grid">
                        <div className="bihar-scheme-card">
                            <div className="bihar-scheme-img"><FaUsers /></div>
                            <div className="bihar-scheme-title">{t("scheme1")}</div>
                        </div>

                        <div className="bihar-scheme-card">
                            <div className="bihar-scheme-title centered-scheme">{t("scheme2")}</div>
                        </div>

                        <div className="bihar-scheme-card">
                            <div className="bihar-scheme-img"><FaFileAlt /></div>
                            <div className="bihar-scheme-title">{t("scheme3")}</div>
                        </div>

                        <div className="bihar-scheme-card">
                            <div className="bihar-scheme-title centered-scheme">{t("scheme4")}</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* IMPORTANT LINKS SECTION */}
            <section className="bihar-important-links-section">
                <div className="bihar-il-header">
                    <h2>{t("footer.importantLinks")}</h2>
                    <button type="button" className="bihar-top-btn" onClick={scrollToTop}>
                        <FaArrowUp /> {t("top")}
                    </button>
                </div>

                <div className="bihar-links-grid">
                    {importantLinksData.map((item, idx) => (
                        <a key={idx} href="#important-links" className="bihar-link-item">
                            <div className="bihar-link-icon-box">
                                <span className="bihar-doc-badge">DOC</span>
                                {getLinkIcon(item.type)}
                            </div>
                            <span className="bihar-link-text">{item.titleKey ? t(item.titleKey) : item.title}</span>
                        </a>
                    ))}
                </div>
            </section>

            {/* MEDIA GALLERY SECTION */}
            <section className="bihar-media-gallery-section">
                <h2>{t("mediaGalleryHeading")}</h2>
                <div className="bihar-mg-grid">
                    <div className="bihar-mg-card">
                        <h3>{t("photoGallery")}</h3>
                        <div className="bihar-mg-icon"><FaImages /></div>
                        <button type="button" className="bihar-mg-btn">{t("viewMore")} →</button>
                    </div>

                    <div className="bihar-mg-card">
                        <h3>{t("videoGallery")}</h3>
                        <div className="bihar-mg-icon"><FaVideo /></div>
                        <button type="button" className="bihar-mg-btn">{t("viewMore")} →</button>
                    </div>

                    <div className="bihar-mg-card">
                        <h3>{t("publications")}</h3>
                        <div className="bihar-mg-icon"><FaNewspaper /></div>
                        <button type="button" className="bihar-mg-btn">{t("viewMore")} →</button>
                    </div>

                    <div className="bihar-mg-card">
                        <h3>{t("feedback")}</h3>
                        <div className="bihar-mg-icon"><FaCommentDots /></div>
                        <button type="button" className="bihar-mg-btn">{t("viewMore")} →</button>
                    </div>
                </div>
            </section>

            {/* BOTTOM UTILITY / LOGOS BAR */}
            <footer className="bihar-bottom-utility-bar">
                <div className="bihar-utility-container">
                    <a href="https://india.gov.in" target="_blank" rel="noreferrer">india.gov.in</a>
                    <span className="bihar-util-divider">|</span>
                    <a href="#cmrf">{t("footer.cmrf")}</a>
                    <span className="bihar-util-divider">|</span>
                    <a href="#compliance">{t("footer.compliance")}</a>
                    <span className="bihar-util-divider">|</span>
                    <a href="#jaankari">{t("footer.jaankari")}</a>
                    <span className="bihar-util-divider">|</span>
                    <a href="#loksamvad">{t("footer.loksamvad")}</a>
                    <span className="bihar-util-divider">|</span>
                    <div className="bihar-helpline">
                        <FaPhoneAlt /> {t("helpline")}: {localizeNumber("(0612)-2233333")}
                    </div>
                    <span className="bihar-util-divider">|</span>
                    <a href="https://in.gov" target="_blank" rel="noreferrer">in.gov</a>
                </div>
            </footer>
        </div>

    );
}
